import React from "react";

export default function WhatsAppButton({ vehicle }) {
  if (!vehicle) return null;

  const message = `Bonjour, je suis intéressé(e) par la ${vehicle.marque} ${vehicle.modele} (${vehicle.annee})`;
  const whatsappUrl = `https://wa.me/22879309400?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="position-fixed bottom-0 end-0 m-4 bg-success text-white rounded-circle p-3 shadow"
      style={{ zIndex: 1050 }}
    >
      <i className="bi bi-whatsapp fs-4"></i>
    </a>
  );
}
